import { inject, Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "../util/translate.service";
import { TRANSLATION_KEYS } from "../constants/translations/translation-keys";

/**
 * Pipe per formattare una data come tempo relativo (es: "5m fa", "2h fa", "3g fa")
 *
 * @example
 * {{ notification.createdAt | relativeTime }}
 * // Output: "5m fa" (italiano) o "5m ago" (inglese)
 */
@Pipe({
  name: "relativeTime",
  standalone: true
})
export class RelativeTimePipe implements PipeTransform {
  private i18n = inject(TranslateService);

  transform(date: Date | string | null | undefined): string {
    if (!date) {
      return "";
    }

    const now = new Date();
    const then = new Date(date);
    const diffMs = now.getTime() - then.getTime();

    // Calcola le differenze
    const diffMinutes = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    // Meno di 1 minuto
    if (diffMinutes < 1) {
      return this.translate(TRANSLATION_KEYS.notifications.MOMENTS_AGO);
    }

    // Meno di 1 ora
    if (diffHours < 1) {
      return `${diffMinutes}${this.translate(TRANSLATION_KEYS.notifications.MINUTES_AGO)}`;
    }

    // Meno di 24 ore
    if (diffDays < 1) {
      return `${diffHours}${this.translate(TRANSLATION_KEYS.notifications.HOURS_AGO)}`;
    }

    // 1 giorno o più
    return `${diffDays}${this.translate(TRANSLATION_KEYS.notifications.DAYS_AGO)}`;
  }

  private translate(key: string): string {
    if (!this.i18n.translation) {
      return key;
    }
    return this.i18n.translation[key] ?? key;
  }
}
